// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"270":"932e7b17eb75c16e","888":"1fa8f94bde4d50eb"}[chunkId] + ".css";
};